import { showBendingCheckSummary } from './bending-summary-view.js'
import { showShearCheckSummary } from './shear-summary-view.js'

export function showDesignSummary(project, results) {
  document.getElementById('design-summary-div').classList.remove('d-none')
  const bendingUnity = results["bending_checks"]["controlling_unity"];
  const shearUnity = results["shear_checks"]["controlling_unity"];
  const deflectionUnity = results["deflection_checks"]["controlling_unity"];
  if( bendingUnity < 1.0 && shearUnity < 1.0 && deflectionUnity < 1.0 ){
      configureCardAppearance('top-design-summary-panel', true)
      configureCardAppearance('design-summary-panel', true)
      let designStr = project.design.designType === 'None' ? 'Beam OK' : 'Design OK'
      $('.current-design-status').html(`<i class="fa fa-check"></i> ${designStr}`)
  }else{
      configureCardAppearance('top-design-summary-panel', false)
      configureCardAppearance('design-summary-panel', false)
      $('.current-design-status').html('<i class="fa fa-remove"></i> Failed');
  }
  document.getElementById('design-summary-load-combination').innerHTML = project.designTypeStr + ' - '
  document.getElementById('design-summary-shape').innerHTML = project.shapeName + ' '
  let materialName = project.isCustom ? "" : project.materialName;
  if(project.isEngineeredLumber) {
      materialName = project.materialGradeName;
  } else if(project.isWood) {
      materialName += ` ${project.materialGradeName}`
  }

  document.getElementById('design-summary-material').innerHTML = materialName

  showBendingCheckSummary(project, results)
  showShearCheckSummary(project, results)
  showDeflectionCheckSummary(project, results)
  showDesignInfoSummary(project, results)
}

export function configureCardAppearance(elementId, designOk) {
  const element = document.getElementById(elementId)
  if(designOk) {
      element.classList.remove('ws-design-failed')
      element.classList.add('ws-design-succeeded')
  } else {
      element.classList.add('ws-design-failed')
      element.classList.remove('ws-bg-success')
  }
}

function showDeflectionCheckSummary(project, results) {
  //get service case results...
  var design = project.design;
  var checks = results["deflection_checks"];
  var controlling_unity = checks["controlling_unity"];
  var controlling_case = checks["controlling_case"];
  var max_dy = checks["max_dy"];
  var success = controlling_unity < 1.0;
  var designStatusStr = success ? '<i class="fa fa-check"></i>' : '<i class="fa fa-remove"></i>';
  configureCardAppearance('deflection-design-panel', success)

  let str = `
  <div class="card-header">
      <div class="fs-6">
          ${designStatusStr} Deflection
          <span class="float-end">${controlling_unity.toFixed(2)}</span>
      </div>
  </div>

  <div class="bg-white rounded-2">
  <table class="table table-borderless">
      <tr>
          <td>Based On</td>
          <td><span style='float:right;'>Service Cases</span></td>
      </tr>

      <tr>
          <td>Controlling Service Case</td>
          <td><span style='float:right;'>${controlling_case }</span></td>
      </tr>

      <tr>
          <td>Max Dy</td>
          <td><span style='float:right;'>${showSmallLengthWithUnits(max_dy)}</span></td>
      </tr>

      <tr>
          <td>Live Load Limit</td>
          <td><span style='float:right;'>L/${design.liveLoadLimit}</span></td>
      </tr>

      <tr>
          <td>Dead + Live Limit</td>
          <td><span style='float:right;'>L/${design.deadPlusLiveLoadLimit}</span></td>
      </tr>

      <tr>
          <td>Snow or Wind Limit</td>
          <td><span style='float:right;'>L/${design.snowOrWindLoadLimit}</span></td>
      </tr>

      <tr>
          <td>Total Load Limit</td>
          <td><span style='float:right;'>L/${design.totalLoadLimit}</span></td>
      </tr>`

  if(project.isEngineeredLumber) {
      str += `
      <tr>
          <td>Shear Deformation Included</td>
          <td><span style='float:right;'>Asx = A(5 + 5&nu;)/(6 + 5&nu;)</span></td>
      </tr>`
  }
  str += "</table></div>";
  document.getElementById("deflection-design-panel").innerHTML = str
}

function showDesignInfoSummary(project, results) {
  const design = project.design;
  var checks = results["deflection_checks"];
  var controlling_unity = checks["controlling_unity"];
  var success = controlling_unity < 1.0;
  configureCardAppearance('design-info-summary-panel', success)
  let str = `
      <div class="card-header">
          <div class="fs-6">
              Design Info
              <span class="float-end">${project.designTypeStr}</span>
          </div>
      </div>`

  str += "<div class='bg-white rounded-2'><table class='table table-borderless'>";
  str += "<tr>";
  str += "<td>Shape Type</td>";
  str += "<td><span style='float:right;'>"+ project.shapeName +"</td></tr>";

  if(project.isEngineeredLumber || project.isWood) {
      str += "<tr>";
      str += "<td>Number of Plys</td>";
      str += "<td><span style='float:right;'>"+ project.numberOfPlys + "</td></tr>";
  }

  if(project.shape.flitch) {
      const thickness = project.shape.flitch.plateThickness
      const height = project.shape.flitch.plateHeight
      const nPlates = project.shape.flitch.numberOfPlates
      str += "<tr>";
      str += "<td>Flitch Steel</td>";
      str += `<td><span style='float:right;'>${nPlates}-${thickness}&times;${height}</td></tr>`
  }

  str += "<tr>";
  str += `<td>Weight ${project.shape.flitch ? "(includes flitch steel)" : ""}</td>`
  str += "<td><span style='float:right;'>"+ project.shapeWeightString +"</td></tr>";

  str += "<tr>";
  str += "<td>Self Weight</td>";
  str += "<td><span style='float:right;'>"+ ((design.includeSelfWeight) ? "Included" : "Not Included") + "</td></tr>";

  str += "<tr>";
  str += `<td>Ix ${project.shape.flitch ? "(includes flitch steel)" : ""}</td>`
  str += "<td><span style='float:right;'>"+ project.shapeIxString + "</td></tr>";

  if(!project.isEngineeredLumber && !project.isCustom && !project.isFormTechShape) {
      str += "<tr>";
      str += "<td>Iy</td>";
      str += "<td><span style='float:right;'>"+ project.shapeIyString + "</td></tr>";

      str += "<tr>";
      str += "<td>Cross Section Rotation</td>";
      str += "<td><span style='float:right;'>"+ project.beam.crossSectionRotation + "&deg;</td></tr>";
  }

  str += "<tr>";
  str += "<td>Bracing</td>";

  //continuous, equal, custom, unbraced
  if(project.isEngineeredLumber) {
      str += "<td><span style='float:right;'>Continuous</span></td></tr>";
  } else if( design.bracingType === 'continuous' ) {
      str += "<td><span style='float:right;'>Continuous</span></td></tr>";
  }else if( design.bracingType === "equal" ){
      str += "<td><span style='float:right;'>Braced @ " + showSmallLengthWithUnits(project.design.getBraceSpacing()) +"</span></td></tr>";
  }else if( design.bracingType === "unbraced" ){
      str += "<td><span style='float:right;'>None</span></td></tr>";
  }else{
      str += "<td><span style='float:right;'>Custom</span></td></tr>";
      str += "<tr>";
      str += "<td>At Inflection Points</td>";
      if( design.bracesAtInflectionPoints ){
          str += "<td><span style='float:right;'>Yes</span></td></tr>";
      }else{
          str += "<td><span style='float:right;'>No</span></td></tr>";
      }
  }

  if(project.isWood && project.design.designType !== 'None' && (project.design.useLambdaOrCd || project.design.useRepetitiveMemberFactor)) {
      str += '<td>'
      let separator = ''
      if(project.design.useLambdaOrCd && project.design.designType === 'LRFD') {
          str += '&lambda; (time effect)'
          separator = ', '
      } else if(project.design.useLambdaOrCd && project.design.designType === 'ASD') {
          str += 'C<sub>D</sub> (load duration)'
          separator = ', '
      } 

      if(project.design.useRepetitiveMemberFactor) {
          str += separator + 'Repetitive Member'
      }
      str += "</td><td><span style='float:right;'>Included</span></td>"
  }

  str += "</table></div>";
  document.getElementById("design-info-summary-panel").innerHTML = str
}
